// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableStyleClass {\n  background: #1b5eb3 !important;\n  color: white;\n}\n.tab_style {\n  margin-top: 20px;\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
